import { FETCH_USERS_PAGINATED } from '@/store/actionTypes'

export const SET_SPACE_MEMBERS_SORTING_STATE = 'SET_SPACE_MEMBERS_SORTING_STATE'
export const SET_EDIT_SPACE_MEMBER = 'SET_EDIT_SPACE_MEMBER'
export const SET_FILTER_SPACE_MEMBER = 'SET_FILTER_SPACE_MEMBER'
export const SET_NEW_SPACE_MEMBER = 'SET_NEW_SPACE_MEMBER'
export const RESET_SPACE_MEMBERS_PAGINATION_STATE = 'RESET_SPACE_MEMBERS_PAGINATION_STATE'

export const FETCH_SPACE_MEMBERS = `${FETCH_USERS_PAGINATED}_SPACE_MEMBERS`
export const FETCH_SPACE_MEMBERS_SUCCESS = `${FETCH_SPACE_MEMBERS}_SUCCESS`

export const REMOVE_MEMBER_FROM_SPACE = 'spaces/members/REMOVE'
export const REMOVE_MEMBER_FROM_SPACE_SUCCESS = `${REMOVE_MEMBER_FROM_SPACE}_SUCCESS`
